import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'
import { dateService, FORMATS } from '@/global/services/date'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      const { id, date } = event?.data || {}
      this.$router.push({
        name: 'Expense',
        params: {
          id
        },
        query: {
          expense_date: date ? dateService.formatCustom(date, FORMATS.isoDatetime, FORMATS.datetimeShort) : DEFAULT_EMPTY_VALUE
        }
      }).then()
    },

    onExpenseDelete (event) {
      const { id, date } = event?.data || {}
      if (!id) {
        return
      }

      const displayDate = date ? dateService.formatCustom(date, FORMATS.isoDatetime, FORMATS.datetimeShort) : '/'
      const title = this.$t('administration/expense.expense_deletion')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + displayDate)
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('administration/expense.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.expenseDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async expenseDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.expenses || {}

        await api('administration').delete(`expenses/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
